module.exports = __webpack_public_path__ + "img/approval.80a68e08.png";